import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Project1Page from './pages/Project1Page';
import RustCratesOverviewPage from './pages/RustCratesOverviewPage';
import CliChatCratePage from './pages/CliChatCratePage';
import IntensePomodoroCratePage from './pages/IntensePomodoroCratePage';
import CoolCliInputPage from './pages/CoolCliInputPage';
import BlogPage from './pages/BlogPage';
import ChatWithAIPage from './pages/ChatWithAIPage';
import Experiance from './pages/Experiance';
import NavigationBar from './components/NavigationBar';
import { ThemeProvider, useTheme } from './context/ThemeContext';

function AppContent() {
  const { theme, toggleTheme } = useTheme();

  return (
    <Router>
      <div className="App">
        <NavigationBar theme={theme} toggleTheme={toggleTheme} />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/project1" element={<Project1Page />} />
            <Route path="/rust-crates" element={<RustCratesOverviewPage />} />
            <Route path="/rust-crates/cli-chat" element={<CliChatCratePage />} />
            <Route path="/rust-crates/intense-pomodoro" element={<IntensePomodoroCratePage />} />
            <Route path="/cli_input" element={<CoolCliInputPage />} />
            <Route path="/rust-crates/bens-chat-cli" element={<Navigate to="/rust-crates/cli-chat" replace />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/experience" element={<Experiance />} />
            <Route path="/chat" element={<ChatWithAIPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
